import { render, staticRenderFns } from "./video-call-notification-popup.html?vue&type=template&id=c3aa458a&scoped=true&external"
import script from "./video-call-notification-popup.js?vue&type=script&lang=js&external"
export * from "./video-call-notification-popup.js?vue&type=script&lang=js&external"
import style0 from "./video-call-notification-popup.scss?vue&type=style&index=0&id=c3aa458a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3aa458a",
  null
  
)

export default component.exports